"use strict";

// Source: https://github.com/angular-ui/bootstrap/blob/master/src/buttons/buttons.js
// Add option to set an uncheckable checkbox with 'btn-uncheckable="angularExpression"'
angular.module("core")
.directive('wgBtnCheckbox', function($parse) {
    return {
        require: ['wgBtnCheckbox', 'ngModel'],
        controller: 'UibButtonsController',
        controllerAs: 'button',
        link: function(scope, element, attrs, ctrls) {
            var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
            var uncheckableExpr = $parse(attrs.wgBtnUncheckable);

            element.find('input').css({display: 'none'});

            function getTrueValue() {
                return getCheckboxValue(attrs.btnCheckboxTrue, true);
            }

            function getFalseValue() {
                return getCheckboxValue(attrs.btnCheckboxFalse, false);
            }

            function getCheckboxValue(attribute, defaultValue) {
                return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
            }

            //model -> UI
            ngModelCtrl.$render = function() {
                element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
            };

            //ui->model
            element.on(buttonsCtrl.toggleEvent, function() {
                if (attrs.disabled || attrs.uncheckable) {
                    return;
                }

                scope.$apply(function() {
                    ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
                    ngModelCtrl.$render();
                });
            });

            scope.$watch(uncheckableExpr, function(uncheckable) {
                attrs.$set('uncheckable', uncheckable);
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/wg-btn-checkbox/wg-btn-checkbox.directive.js
// module id = 505
// module chunks = 0